import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../app/stores/store';
import axios from 'axios';
import agent from '../../../../app/api/agent';
import { Form, Select } from 'semantic-ui-react';

function Workflow() {
  // -------------------- Stores ------------------------ //
  const { DashboardConfigurationStore, sidebarStore } = useStore();
  const { workflow } = DashboardConfigurationStore;

  const {
    details,
    assetOptions,
    elementOptions,
    templateOptions,
    isAssetLoading,
    isElementLoading,
    isTemplateLoading,
  } = workflow || {};

  useEffect(() => {
    DashboardConfigurationStore.workflow.details = {
      ...DashboardConfigurationStore.workflow.details,
      masterOptions: sidebarStore.masterFormList?.map((data) => ({
        key: data.masterId,
        value: data.title,
        text: data.title,
      })),
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    try {
      DashboardConfigurationStore.workflow = {
        ...DashboardConfigurationStore.workflow,
        isAssetLoading: true,
      };
      (async () => {
        let result = await axios.get<any>(`/AssetTypes/AssetTypeOnly`);
        if (result.data) {
          let data = result.data?.map(
            (data: { id: string; typeName: string }) => {
              return {
                key: data.id,
                value: data.typeName,
                text: data.typeName,
              };
            },
          );
          DashboardConfigurationStore.workflow = {
            ...DashboardConfigurationStore.workflow,
            assetOptions: data,
          };
        }
        DashboardConfigurationStore.workflow = {
          ...DashboardConfigurationStore.workflow,
          isAssetLoading: false,
        };
      })();
    } catch {
      DashboardConfigurationStore.workflow = {
        ...DashboardConfigurationStore.workflow,
        isAssetLoading: false,
      };
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!details.asset.assetId?.length) return;

    DashboardConfigurationStore.workflow = {
      ...DashboardConfigurationStore.workflow,
      isElementLoading: true,
    };
    (async () => {
      try {
        if (details.asset.assetId) {
          let result = await agent.ElementTypes.getElementTypeByAssetType(
            details.asset.assetId || '',
          );
          let filter = (result || [])?.flatMap((data) => {
            return data.isDeleted
              ? []
              : {
                  key: data.id,
                  value: data.elementName,
                  text: data.elementName,
                };
          });
          DashboardConfigurationStore.workflow = {
            ...DashboardConfigurationStore.workflow,
            elementOptions: filter,
          };
        }
        DashboardConfigurationStore.workflow = {
          ...DashboardConfigurationStore.workflow,
          isElementLoading: false,
        };
      } catch {
        DashboardConfigurationStore.workflow = {
          ...DashboardConfigurationStore.workflow,
          isElementLoading: false,
        };
      }
    })();
    // eslint-disable-next-line
  }, [details.asset.assetId]);

  useEffect(() => {
    if (!details.asset.assetId?.length) return;

    DashboardConfigurationStore.workflow = {
      ...DashboardConfigurationStore.workflow,
      isTemplateLoading: true,
    };
    (async () => {
      try {
        if (details.element.elementId) {
          let result = await agent.Templates.gettemplateTypeByElementType(
            details.element.elementId || '',
          );
          let filter = (result || [])?.flatMap((data) => {
            return data.isDeleted
              ? []
              : {
                  key: data.templateId,
                  value: data.templateName,
                  text: data.templateName,
                };
          });
          DashboardConfigurationStore.workflow = {
            ...DashboardConfigurationStore.workflow,
            templateOptions: filter,
          };
        }
        DashboardConfigurationStore.workflow = {
          ...DashboardConfigurationStore.workflow,
          isTemplateLoading: false,
        };
      } catch {
        DashboardConfigurationStore.workflow = {
          ...DashboardConfigurationStore.workflow,
          isTemplateLoading: false,
        };
      }
    })();
    // eslint-disable-next-line
  }, [details.element.elementId]);

  return (
    <div className="workflowConfigWrapper" style={{ marginTop: '12px' }}>
      <h4>Configure the Workflow</h4>
      <Form>
        <DynamicComponent
          loading={isAssetLoading}
          label={'Select Asset type'}
          value={details.asset.name || ''}
          options={assetOptions}
          onchange={(data: { name: string; id: string }) =>
            (DashboardConfigurationStore.workflow = {
              ...DashboardConfigurationStore.workflow,
              details: {
                ...DashboardConfigurationStore.workflow.details,
                asset: {
                  assetId: data.id,
                  name: data.name,
                },
                element: {
                  elementId: '',
                  name: '',
                },
                template: {
                  templateId: '',
                  name: '',
                },
              },
            })
          }
        />
        {!!details.asset.assetId?.length && (
          <DynamicComponent
            label={'Select Element type'}
            value={details.element.name || ''}
            options={elementOptions}
            loading={isElementLoading}
            onchange={(data: { name: string; id: string }) =>
              (DashboardConfigurationStore.workflow = {
                ...DashboardConfigurationStore.workflow,
                details: {
                  ...DashboardConfigurationStore.workflow.details,
                  element: {
                    elementId: data.id,
                    name: data.name,
                  },
                  template: {
                    templateId: '',
                    name: '',
                  },
                },
              })
            }
          />
        )}
        {!!details.asset.assetId?.length &&
          !!details.element.elementId?.length && (
            <DynamicComponent
              label={'Select Template type'}
              value={details.template.name || ''}
              options={templateOptions}
              loading={isTemplateLoading}
              onchange={(data: { name: string; id: string }) =>
                (DashboardConfigurationStore.workflow = {
                  ...DashboardConfigurationStore.workflow,
                  details: {
                    ...DashboardConfigurationStore.workflow.details,
                    template: {
                      templateId: data.id,
                      name: data.name,
                    },
                  },
                })
              }
            />
          )}
        <Form.Field
          label={'Select Master'}
          control={Select}
          placeholder={'Select Master'}
          clearable
          fluid
          search
          selection
          options={
            DashboardConfigurationStore.workflow.details.masterOptions || []
          }
          onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
            if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
              e.stopPropagation();
          }}
          style={{ marginTop: '5px' }}
          value={DashboardConfigurationStore.workflow.details.masterName}
          onChange={(_e: any, { value }: { value: string }) =>
            (DashboardConfigurationStore.workflow.details.masterName = value)
          }
        />
      </Form>
    </div>
  );
}

function DynamicComponent({
  options,
  value,
  onchange,
  label,
  isDisabled,
  loading,
}: any) {
  return (
    <Form.Field
      loading={loading}
      disabled={isDisabled}
      options={options}
      control={Select}
      placeholder={label}
      search
      clearable
      value={value}
      onChange={(_e: any, { value }: { value: string }) => {
        let key =
          options?.find((data: { value: string }) => data.value === value)
            ?.key || '';
        if (key === 'Sorry, No data') return;
        onchange({
          id: key,
          name: value,
        });
      }}
    />
  );
}

export default observer(Workflow);
